import { render, staticRenderFns } from "./HomeLeft.vue?vue&type=template&id=3b21b33c&scoped=true&"
import script from "./HomeLeft.vue?vue&type=script&lang=js&"
export * from "./HomeLeft.vue?vue&type=script&lang=js&"
import style0 from "./HomeLeft.vue?vue&type=style&index=0&id=3b21b33c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b21b33c",
  null
  
)

export default component.exports